export const quotesSymbolsRoutes = {
  detailedQuotes: { proxy: 'quotes/detailed', upstream: 'v2/quote' },
} as const;
